import { render, staticRenderFns } from "./ShainSetteiK.vue?vue&type=template&id=341dab8e&scoped=true"
import script from "./ShainSetteiK.vue?vue&type=script&lang=js"
export * from "./ShainSetteiK.vue?vue&type=script&lang=js"
import style0 from "./ShainSetteiK.vue?vue&type=style&index=0&id=341dab8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "341dab8e",
  null
  
)

export default component.exports